export var LOCALE = {
  ru: 'ru',
  uk: 'uk'
};
export var SCROLL_INTO_VIEW = {
  start: 'start',
  smooth: 'smooth'
};
export var LINK = {
  blank: '_blank',
  relIsolated: 'noopener noreferrer nofollow noindex'
};
export var MORE_INFO_NAMES = {
  payments: 'payments',
  service: 'service',
  cashWithdrawal: 'cashWithdrawal',
  cashDeposit: 'cashDeposit'
};